import React, { FC } from 'react';

import { arrowDown, arrowUp } from 'assets/icons';
import { ColumnSorting } from 'helpers/getColumnSorting';
import { SvgWrapper } from 'components/atoms/svg-wrapper';

import styles from './styles.module.css';

interface IInfoTableSortIndicatorProps {
  sortBy: string | null;
}

export const InfoTableSortIndicator: FC<IInfoTableSortIndicatorProps> = ({ sortBy }) =>
  sortBy ? (
    <SvgWrapper
      width={7}
      height={7}
      details={sortBy === ColumnSorting.Desc ? arrowUp : arrowDown}
      style={{ bottom: '3px', marginLeft: '10px' }}
    />
  ) : (
    <span className={styles.sortIcons}>
      <SvgWrapper width={7} height={7} details={arrowUp} />
      <SvgWrapper width={7} height={7} details={arrowDown} />
    </span>
  );
